// LumiCasa: robust hover dropdown with real leave delay (works on Dawn)
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.header .header__inline-menu li');

  items.forEach(function (li) {
    const details = li.querySelector('details');
    // sve moguće podmenije koje Dawn može koristiti
    const submenu =
      li.querySelector('.header__submenu, .list-menu--disclosure, .list-menu--sub, .list-menu');

    let closeTimer;

    const open = () => {
      if (!details) return;
      clearTimeout(closeTimer);
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    };

    const scheduleClose = () => {
      if (!details) return;
      clearTimeout(closeTimer);
      // povećaj ako želiš sporije zatvaranje (npr. 250–300ms)
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
      }, 220);
    };

    // držimo otvorenim kad si na LI (roditelju)
    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', scheduleClose);

    // i kad si na samom submenuu – dodatno osiguranje
    if (submenu) {
      submenu.addEventListener('mouseenter', open);
      submenu.addEventListener('mouseleave', scheduleClose);
    }

    // a11y: tipkovnica
    li.addEventListener('focusin', open);
    li.addEventListener('focusout', (e) => {
      if (!li.contains(e.relatedTarget)) scheduleClose();
    });
  });
});

